import * as actionTypes from "./actionTypes";

/************** Archival Management **********************/
const archivalManagementInitialState = {
  processing: false,
  loadingChannel: false,
  channel: null,
};
export const archivalManagementReducer = (
  state = archivalManagementInitialState,
  action
) => {
  const { type, payload } = action;

  switch (type) {
    case actionTypes.RESET_ARCHIVAL_MANAGEMENT:
      return archivalManagementInitialState;
    case actionTypes.SET_PROCESSING_ARCHIVAL_MANAGEMENT:
      return { ...state, processing: true };
    case actionTypes.STOP_PROCESSING_ARCHIVAL_MANAGEMENT:
      return { ...state, processing: false };
    case actionTypes.LOAD_CHANNEL:
      return { ...state, loadingLicense: true };
    case actionTypes.STOP_LOAD_CHANNEL:
      return { ...state, loadingLicense: false };
    case actionTypes.GET_CHANNEL:
      return { ...state, loadingLicense: false, channel: payload[0] };
    case actionTypes.UPDATE_CHANNEL:
      return { ...state, processing: false, channel: payload };
    case actionTypes.CREATE_CHANNEL:
      return { ...state, processing: false, channel: payload };
    default:
      return state;
  }
};

/************** BANK SETTINGS **********************/
const bankSettingsInitialState = {
  processing: false,
  loadingConfiguration: false,
  configuration: null,
  currencies: null,
  uatMode: false,
  sendingTestEmail: false,
};
export const bankSettingsReducer = (
  state = bankSettingsInitialState,
  action
) => {
  const { type, payload } = action;

  switch (type) {
    case actionTypes.RESET_BANK_SETTINGS:
      return bankSettingsInitialState;
    case actionTypes.SET_PROCESSING_BANK_SETTINGS:
      return { ...state, processing: true };
    case actionTypes.STOP_PROCESSING_BANK_SETTINGS:
      return { ...state, processing: false };
    case actionTypes.LOAD_CONFIGURATION:
      return { ...state, loadingConfiguration: true };
    case actionTypes.STOP_LOAD_CONFIGURATION:
      return { ...state, loadingConfiguration: false };
    case actionTypes.GET_CURRENCIES:
      return {
        ...state,
        currencies: payload,
      };
    case actionTypes.GET_CONFIGURATION:
      return {
        ...state,
        loadingConfiguration: false,
        configuration: payload,
        uatMode: payload.isUATMode,
      };
    case actionTypes.UPDATE_CONFIGURATION:
      return { ...state, processing: false, configuration: payload };
    case actionTypes.CREATE_CONFIGURATION:
      return { ...state, processing: false, configuration: payload };
    case actionTypes.TOGGLE_UAT:
      return { ...state };
    case actionTypes.SEND_TEST_EMAIL:
      return { ...state, sendingTestEmail: true };
    case actionTypes.SET_SENDING_TEST_EMAIL:
      return { ...state, sendingTestEmail: payload };
    default:
      return state;
  }
};

/************** alert & notification **********************/

const alertInitialState = {
  Alerts: null,
  Notifications: null,
  configurationData: null,
  customerSub: null,
  customerFile:null,
  failedCustomers: null,
  Groups: null,
};

export const adminAlertReducer = (state = alertInitialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case actionTypes.LOAD_ALERTS:
      return {
        ...state,
        loadingAlerts: true,
      };
    case actionTypes.GET_ALERT:
      let Alerts = payload.filter((alert) => alert.type === "ALERT");
      let Notifications = payload.filter(
        (notification) => notification.type === "NOTIFICATION"
      );
      let customerSub = payload.filter(
        (notification) =>
          notification.type !== "NOTIFICATION" && notification.type !== "ALERT"
      );

      return {
        ...state,
        loadingAlerts: false,
        Alerts: Alerts,
        Notifications: Notifications,
        customerSub: customerSub,
      };
    case actionTypes.CREATE_ALERT:
      let newTemplate = payload.type === "ALERT" ? true : false;
      return {
        ...state,
        Alerts: newTemplate ? [...state.Alerts, payload] : state.Alerts,
        Notifications: newTemplate
          ? state.Notifications
          : [...state.Notifications, payload],
      };
    case actionTypes.UPDATE_ALERT:
      const nextShapes = state.Alerts.map((shape) => {
        if (shape.id !== payload.id) {
          // No change
          return shape;
        } else {
          return {
            ...shape,
            text: payload.text,
            name: payload.name,
            alertType: payload.alertType,
            isDefault: payload.isDefault,
          };
        }
      });
      const nextShapesNotification = state.Notifications.map((shape) => {
        if (shape.id !== payload.id) {
          // No change
          return shape;
        } else {
          return {
            ...shape,
            text: payload.text,
            name: payload.name,
            isDefault: payload.isDefault,
          };
        }
      });

      return {
        ...state,
        Alerts: nextShapes,
        Notifications: nextShapesNotification,
      };

    case actionTypes.UPDATE_DEFAULT:
      return {};

    case actionTypes.RESET_ALERTS:
      return alertInitialState;

    case actionTypes.DELETE_ALERT:
      const copyOfAlerts = [...state.Alerts];
      const newAlerts = copyOfAlerts.filter((alert) => alert.id !== payload);
      const copyOfNotification = [...state.Notifications];

      const newNotification = copyOfNotification.filter(
        (alert) => alert.id !== payload
      );
      return {
        ...state,
        Alerts: newAlerts,
        Notifications: newNotification,
      };

    case actionTypes.FILTER_DATA:
      const copyToFillterAlerts = [...state.Alerts];
      let afterFiltterAlerts = copyToFillterAlerts.filter(
        (alert) => alert.alertType === payload
      );

      return {
        ...state,
        Alerts: afterFiltterAlerts,
      };

      case actionTypes.CUSTOMER_FILE:
        return {
          ...state,
          customerFile:payload
        }
    case actionTypes.GET_CONFIGURATION:
      return {
        ...state,
        configurationData: payload,
      };
    case actionTypes.FAILED_CUSTOMERS:
      const selectedRows = payload.map((row) => row.account);
      return {
        ...state,
        failedCustomers: selectedRows,
      };
    case actionTypes.ALL_GROUPS:
      return {
        ...state,
        Groups: payload,
      };
    default:
      return state;
  }
};
